export class PersistenceAction {
  public static NONE = 0;
  public static INSERT = 1;
  public static UPDATE = 2;
  public static DELETE = 3;
}
